import { render, staticRenderFns } from "./TargetGroupCMS.vue?vue&type=template&id=889f9c1a&scoped=true&"
import script from "./TargetGroupCMS.vue?vue&type=script&lang=js&"
export * from "./TargetGroupCMS.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupCMS.vue?vue&type=style&index=0&id=889f9c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889f9c1a",
  null
  
)

export default component.exports